













import { Component, Vue } from 'vue-property-decorator';
import { observeUser, signOut } from '@/firebaseApp';
import * as firebase from 'firebase';

@Component
export default class Header extends Vue {
  public user: firebase.User | null = null;

  mounted() {
    observeUser(user => {
      this.user = user;
    });
  }

  async signOutUser() {
    await signOut();
    this.user = null;
    this.$router.push({ name: 'Login' });
  }
}
